// @flow

import dayjs from './dayjs';

export const FORMAT_DEFAULT_DATE = 'DD.MM.YYYY';
export const FORMAT_DEFAULT_TIME = 'HH:mm:ss';
export const FORMAT_DEFAULT_MONTH = 'MM.YYYY';
export const FORMAT_DEFAULT = `${FORMAT_DEFAULT_DATE} ${FORMAT_DEFAULT_TIME}`;

export const formatDate = (
  date: string,
  formatTo: string,
  formatFrom: string = FORMAT_DEFAULT
) => (date ? dayjs(date, formatFrom).format(formatTo) : '');

export const createDateFormater =
  (
    formatTo: string = FORMAT_DEFAULT_DATE,
    formatFrom: string = FORMAT_DEFAULT
  ) =>
  (date: string) =>
    formatDate(date, formatTo, formatFrom);

export const defaultDateFormater = createDateFormater();

export const getDateFromDateTime = (
  date: string,
  formatTo: string = FORMAT_DEFAULT_DATE
) => formatDate(date, formatTo);

export const stringToDayjs = (v, fmt) => {
  if (!v) return null;
  if (dayjs.isDayjs(v)) return v;
  const d = dayjs(v, fmt, true);
  return d.isValid() ? d : null;
};

export const getDateRanges = (t, keyPrefix = 'report.filter.dateRange') => ({
  [t(`${keyPrefix}.currentMonth`)]: [
    dayjs().startOf('month'),
    dayjs().endOf('day'),
  ],
  [t(`${keyPrefix}.beginLastMonth`)]: [
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().endOf('day'),
  ],
  [t(`${keyPrefix}.lastMonth`)]: [
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().subtract(1, 'month').endOf('month').endOf('day'),
  ],
  [t(`${keyPrefix}.currentYear`)]: [
    dayjs().startOf('year'),
    dayjs().endOf('day'),
  ],
  [t(`${keyPrefix}.lastYear`)]: [
    dayjs().subtract(1, 'year').startOf('year'),
    dayjs().subtract(1, 'year').endOf('year').endOf('day'),
  ],
  [t(`${keyPrefix}.last12Months`)]: [
    dayjs().subtract(12, 'month'),
    dayjs().endOf('day'),
  ],
});

export const getBasicFilterDateRanges = (
  t,
  keyPrefix = 'filter.dateRange'
) => ({
  [t(`${keyPrefix}.currentMonth`)]: [
    dayjs().startOf('month'),
    dayjs().endOf('month').endOf('day'),
  ],
  [t(`${keyPrefix}.beginLastMonth`)]: [
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().endOf('day'),
  ],
  [t(`${keyPrefix}.lastMonth`)]: [
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().subtract(1, 'month').endOf('month').endOf('day'),
  ],
});

export const getTransactionDateRanges = (t) =>
  getDateRanges(t, 'transactions.filter.dateRange');
